import { Icon } from "../../../../components/BaseComponents/Icon";

export const CapsuleIcon = (props) => (
	<Icon fill="none" {...props}>
		<path
			d="M15.39 2c1.72 0 3.44.67 4.68 1.9a6.7 6.7 0 0 1 0 9.43l-6.78 6.77a6.66 6.66 0 0 1-9.36 0 6.7 6.7 0 0 1 0-9.43l6.78-6.77A6.7 6.7 0 0 1 15.4 2M6.34 12.56a.5.5 0 0 0-.7-.12 3.6 3.6 0 0 0-1.28 4.2l.1.3a.5.5 0 0 0 .95-.35l-.12-.3a2.6 2.6 0 0 1 .94-3.03.5.5 0 0 0 .11-.7m9.05-8.75c-1.24 0-2.48.57-3.34 1.43L9.37 7.9l6.78 6.77L18.83 12a4.9 4.9 0 0 0 0-6.76 5.3 5.3 0 0 0-3.44-1.43"
			fill="currentColor"
		/>
	</Icon>
);
